import React, { useState, useRef, useContext, useMemo, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-tjIjLI8L.js';
import useShowError from './hooks/useShowError.js';
import 'notistack';
import useWindowSize from './hooks/useWindowSize.js';
import { getAddonName, isProductAvailableForSale } from './utils/product.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import useItemListName from './hooks/useItemListName.js';
import { getCartSessionId, isCartSessionValid, checkCartSessionIdValidity } from './utils/cart.js';
import { getProductDiscount } from './utils/saleFlag.js';
import { processErrorMessage } from './utils/error.js';
import { a as getProductImages, g as getBreadcrumbs, c as calculateStikyTopProduct } from './helper-qZTqmbEO.js';
import get from 'lodash/get';
import { getPrices } from './utils/price.js';
import { a as ProductType, b as ProductTypeRate } from './product-_pRduMz7.js';
import Breadcrumbs from './components/Breadcrumbs/index.js';
import WishlistButton from './components/WishlistButton/index.js';
import JustAddedProducts from './components/JustAddedProducts/index.js';
import ImagesCarousel from './components/ImagesCarousel/index.js';
import { C as CarouselVerticalComponent } from './ImagesCarouselVertical-b9BRMREW.js';
import { S as SaleFlag } from './SaleFlag-uqbhEU3Y.js';
import { U as UpsellProducts } from './UpsellProducts-Wc3lCklO.js';
import { I as ItemCopy } from './ItemCopy-4geL5RN9.js';
import { O as OptionsForm } from './OptionsForm-voXVhl4J.js';
import { P as Prices } from './Prices-J1SqTpik.js';
import { toggleModal } from './store/modal/index.js';
import './types/index.js';
import './checkout-Ee1eEXQH.js';
import './menu-0TyOg98i.js';
import { M as ModalType } from './modal-6vnX5SO3.js';
import { E as EcoFee } from './EcoFee-Ep6rIIu6.js';
import { c as classnames } from './index-2586sEvh.js';

const containsAll = (arr1, arr2) => arr1.every(item => arr2.includes(item));
const getProductVariant = (values, product) => {
    const chosenOptions = Object.entries(values).map(item => item.join(':'));
    const foundProduct = product.variants.find(item => {
        const attributes = item.attributes.map(attribute => `${attribute.code}:${attribute.label}`);
        return containsAll(attributes, chosenOptions);
    });
    return foundProduct;
};
const getRelatedSimpleProductsPayload = (relatedProductsSku, counterValue) => relatedProductsSku.map(sku => ({
    data: {
        quantity: Number(counterValue),
        sku,
    },
}));
const getRelatedConfigurableProductsPayload = (relatedProductsSku, parentProductSku, counterValue) => relatedProductsSku.map(sku => ({
    parent_sku: parentProductSku,
    data: {
        quantity: Number(counterValue),
        sku,
    },
}));
const getRelatedProductsPayload = (product, relatedProductsSku, counterValue) => {
    const simpleProducts = [];
    const configurableProducts = [];
    relatedProductsSku.forEach(relatedSKUProduct => {
        // if product has more than 1 related product, find the index of the related product
        const relatedRootProductIndex = product.related_products.length === 1
            ? 0
            : product.related_products.findIndex(related_product => {
                var _a;
                return related_product.sku === relatedSKUProduct || // if related product is simple product
                    ((_a = related_product.variants) === null || _a === void 0 ? void 0 : _a.some(variant => variant.product.sku === relatedSKUProduct));
            });
        const relatedRootProduct = get(product, ['related_products', relatedRootProductIndex]);
        const isRelatedRootProductConfigurable = get(relatedRootProduct, '__typename') === 'ConfigurableProduct' ||
            get(relatedRootProduct, 'type_id') === ProductType.Configurable;
        const relatedRootProductSku = get(relatedRootProduct, 'sku');
        if (isRelatedRootProductConfigurable) {
            // if Root Related Product is "Configurable" - generate "configurable" payload
            configurableProducts.push(...getRelatedConfigurableProductsPayload([relatedSKUProduct], relatedRootProductSku, counterValue));
        }
        else {
            // if Root Related Product is "Simple" - generate "simple" payload
            simpleProducts.push(...getRelatedSimpleProductsPayload([relatedSKUProduct], counterValue));
        }
    });
    return { simpleProducts, configurableProducts };
};
const getConfigurableProductPayload = (values, counterValue, product) => {
    const foundProduct = getProductVariant(values, product);
    if (!foundProduct)
        return null;
    const { sku } = foundProduct.product;
    return {
        parent_sku: product.sku,
        data: {
            sku,
            quantity: Number(counterValue),
        },
    };
};
const getProductPriceRange = (product, variantProduct, isFormFilled) => {
    if (!isFormFilled || !variantProduct)
        return product.price_range;
    return variantProduct.price_range;
};
const getProductPrices = (product, variantProduct, isFormFilled, locale, noZeroAfterDecimal) => {
    const priceRange = getProductPriceRange(product, variantProduct, isFormFilled);
    return getPrices(priceRange, locale, noZeroAfterDecimal);
};

const ConfigurableProduct = ({ product, wishlistButton, outsideHeading = false, extraContent, accordionExtraContent, }) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation('', { keyPrefix: '' });
    const { asPath, locale } = useRouter();
    const [isAdding, setIsAdding] = useState(false);
    const [counterValue, setCounterValue] = useState(1);
    const [addonCounterValue, setAddonCounterValue] = useState(1);
    const [formValues, setFormValues] = useState({});
    const [isFormFilled, setIsFormFilled] = useState(false);
    const [isSingleOptionProduct, setIsSingleOptionProduct] = useState(false);
    const [justAddedData, setJustAddedData] = useState(null);
    const [selectedRelatedProductsSku, setSelectedRelatedProductsSku] = useState([]);
    const [checkedAddon, setCheckedAddon] = useState([]);
    const [pageReady, setPageReady] = useState(false);
    const [productImages, setProductImages] = useState(getProductImages(product));
    const [thumbnailImage, setThumbnailImage] = useState(((_a = product.thumbnail) === null || _a === void 0 ? void 0 : _a.url) || null);
    const [selectedProductVariant, setSelectedProductVariant] = useState(null);
    const [previewImage] = useState(['']);
    const [hasRetriedAddToCart, setHasRetriedAddToCart] = useState(false);
    const openModalRef = useRef(null);
    const imageWrapRef = useRef(null);
    const { useDispatch, thunks, data: { siteConfig: { product: { headingInProductImage = false, itemCopyDesktop = 'tabs', verticalCarousel = false, breadCrumbPosition = 'top', stickConfigBlock = false, disableDefaultYmal = false, } = {}, cart: { useCartDrawer = false } = {}, accorTagging: { accorTaggingEnabled = false } = {}, promo: { displaySaleFlag = false, discount: promoDiscount = '', productsSaleExcludeList = [], } = {}, noZeroAfterDecimal = false, }, }, } = useContext(CoreContext);
    const { cart: { getCart, addProduct }, } = thunks;
    const itemListName = useItemListName();
    const dispatch = useDispatch();
    const showError = useShowError();
    const breadcrumbItems = getBreadcrumbs(product, locale);
    const productPromoDiscount = getProductDiscount(promoDiscount, product, productsSaleExcludeList);
    const selectedOptions = useMemo(() => {
        if (!selectedProductVariant)
            return [];
        const selectedProduct = product.variants.find(variant => variant.product.sku === selectedProductVariant.sku);
        if (!selectedProduct)
            return [];
        return selectedProduct.attributes.map(attribute => attribute.uid);
    }, [selectedProductVariant]);
    const prices = getProductPrices(product, selectedProductVariant, isFormFilled, locale, noZeroAfterDecimal);
    const showPrice = !isFormFilled || !!selectedProductVariant;
    const windowSize = useWindowSize();
    // Handle page ready state for product options
    useEffect(() => {
        // Reset state on path change
        setPageReady(false);
        // Use requestAnimationFrame to ensure DOM is updated
        const frame = requestAnimationFrame(() => {
            var _a;
            // Check if component is still mounted and product data is available
            if (((_a = product === null || product === void 0 ? void 0 : product.configurable_options) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setPageReady(true);
            }
        });
        return () => cancelAnimationFrame(frame);
    }, [asPath, product === null || product === void 0 ? void 0 : product.configurable_options]);
    const onRelatedProductClick = (name) => {
        if (checkedAddon.includes(name)) {
            // Remove
            setCheckedAddon(prevState => prevState.filter(prevName => prevName !== name));
        }
        else {
            // Add
            setCheckedAddon(prevState => [...prevState, name]);
        }
    };
    const onSubmit = async (values) => {
        setIsAdding(true);
        let justAdded = null;
        const configurableProductPayload = getConfigurableProductPayload(values, counterValue, product);
        const relatedProductsPayload = getRelatedProductsPayload(product, selectedRelatedProductsSku, addonCounterValue);
        const resultAction = await dispatch(addProduct({
            simpleProducts: relatedProductsPayload.simpleProducts,
            configurableProducts: [
                configurableProductPayload,
                ...relatedProductsPayload.configurableProducts,
            ],
            accorTaggingEnabled,
            itemListName,
        }));
        if (addProduct.fulfilled.match(resultAction)) {
            if (!useCartDrawer) {
                justAdded = resultAction.payload;
                // Run getCart() to update MiniShoppingCart popup data
                dispatch(getCart({ cart_id: getCartSessionId(), accorTaggingEnabled }));
            }
            else {
                await dispatch(getCart({ cart_id: getCartSessionId(), accorTaggingEnabled }));
                dispatch(toggleModal(ModalType.ShoppingCart));
            }
        }
        else {
            const error = processErrorMessage(resultAction.payload.errorMessage, t);
            // If cart session is invalid, retry only once
            if (!isCartSessionValid(error) && !hasRetriedAddToCart) {
                checkCartSessionIdValidity(error);
                onSubmit(values);
                setHasRetriedAddToCart(true);
                return;
            }
            showError(error);
        }
        setJustAddedData(justAdded);
        setIsAdding(false);
    };
    const closeHandler = () => {
        setJustAddedData(null);
        if (openModalRef.current) {
            openModalRef.current.focus();
        }
    };
    const onColorChange = (code, value) => {
        var _a;
        if (isFormFilled) {
            return;
        }
        const previewProduct = product.variants.find(variant => variant.attributes.find(attribute => attribute.code === code && attribute.label === value));
        setThumbnailImage(((_a = previewProduct.product.thumbnail) === null || _a === void 0 ? void 0 : _a.url) || null);
        setProductImages(getProductImages(previewProduct.product));
    };
    useEffect(() => {
        if (isFormFilled || isSingleOptionProduct) {
            const foundProduct = getProductVariant(formValues, product);
            setSelectedProductVariant((foundProduct === null || foundProduct === void 0 ? void 0 : foundProduct.product) || null);
            if (foundProduct) {
                // Update to pass additional_images as well
                setProductImages(getProductImages(foundProduct.product));
            }
            else {
                setProductImages(getProductImages(product));
            }
        }
        else if (Object.keys(formValues).length === 0) {
            setSelectedProductVariant(null);
            setProductImages(getProductImages(product));
        }
    }, [isFormFilled, product, formValues, isSingleOptionProduct]);
    useEffect(() => {
        var _a;
        if (selectedProductVariant) {
            // here we want to map the checkedAddon product and modify selectedRelatedProductsSku
            const relatedProductsSku = [];
            checkedAddon.forEach(addon => {
                selectedProductVariant.related_products.forEach(relatedProduct => {
                    const isAvailable = addon === getAddonName(relatedProduct.name_en.product_name) &&
                        isProductAvailableForSale(relatedProduct.backorder_status, relatedProduct.stock_status) &&
                        isProductAvailableForSale(selectedProductVariant.backorder_status, selectedProductVariant.stock_status);
                    if (isAvailable) {
                        relatedProductsSku.push(relatedProduct.sku);
                    }
                });
            });
            setSelectedRelatedProductsSku(relatedProductsSku);
            // change thubnail to use selected variant
            setThumbnailImage(((_a = selectedProductVariant.thumbnail) === null || _a === void 0 ? void 0 : _a.url) || null);
        }
        else {
            setSelectedRelatedProductsSku([]);
        }
    }, [selectedProductVariant, checkedAddon]);
    useEffect(() => {
        var _a;
        // Reset state values when switching between a product pages via browser navbar
        setIsAdding(false);
        setCounterValue(1);
        setAddonCounterValue(1);
        setFormValues({});
        setIsFormFilled(false);
        setJustAddedData(null);
        setCheckedAddon([]);
        setSelectedRelatedProductsSku([]);
        setSelectedProductVariant(null);
        setThumbnailImage(((_a = product === null || product === void 0 ? void 0 : product.thumbnail) === null || _a === void 0 ? void 0 : _a.url) || null);
    }, [asPath]);
    useEffect(() => {
        if (stickConfigBlock) {
            calculateStikyTopProduct(imageWrapRef.current);
            window.addEventListener('resize', () => calculateStikyTopProduct(imageWrapRef.current));
        }
    }, []);
    const blocNameImage = `product image ${product.name}`;
    return (React.createElement("div", { className: classnames('clearfix', 'product-page', 'product-configurable', {
            'product-vertical-carousel': verticalCarousel,
        }) },
        React.createElement("section", null,
            breadCrumbPosition === 'top' && (React.createElement(Breadcrumbs, { items: breadcrumbItems, currentItem: product.name })),
            React.createElement("div", { className: "product" },
                outsideHeading && !headingInProductImage && React.createElement("h1", null, product.name),
                React.createElement("div", { className: "product-image-wrap", ref: imageWrapRef },
                    React.createElement(SaleFlag, { show: displaySaleFlag, discount: productPromoDiscount }),
                    verticalCarousel && windowSize.width > 768 ? (React.createElement("div", { className: "product-slider-wrapper vertical-carousel", "data-event-name": "bloc_interact", "data-bloc-name": blocNameImage },
                        React.createElement(CarouselVerticalComponent, { items: productImages, thumbnailImage: thumbnailImage, title: product.name }))) : (React.createElement("div", { className: "product-slider-wrapper", "data-event-name": "bloc_interact", "data-bloc-name": blocNameImage },
                        React.createElement(ImagesCarousel, { items: productImages, thumbnailImage: thumbnailImage, title: product.name, preview: previewImage }))),
                    React.createElement("div", { className: "product-config-wrapper" },
                        React.createElement("div", { className: "product-config" },
                            breadCrumbPosition === 'product-config' && (React.createElement(Breadcrumbs, { items: breadcrumbItems, currentItem: product.name })),
                            React.createElement("div", { className: "inner-wrapper" },
                                !outsideHeading && !headingInProductImage && (React.createElement("div", { className: "product-config-row product-config-name" },
                                    React.createElement("h1", { "data-name_en": product.name_en.product_name, className: "font-sub-heading", "data-event-name": "bloc_interact", "data-bloc-name": `product name ${product.name}` }, ((_b = product.product_subtitle) === null || _b === void 0 ? void 0 : _b.trim())
                                        ? `${product.name} - ${product.product_subtitle}`
                                        : product.name),
                                    wishlistButton && (React.createElement("div", { className: "product-config-wishlist" },
                                        React.createElement(WishlistButton, { product: product, childSku: selectedProductVariant === null || selectedProductVariant === void 0 ? void 0 : selectedProductVariant.sku, selectedOptions: selectedOptions }))))),
                                React.createElement("div", { className: "product-config-column product-config-price" },
                                    React.createElement(Prices, { show: showPrice, prices: prices, className: "product-config-prices" })),
                                !!((_c = product.configurable_options) === null || _c === void 0 ? void 0 : _c.length) && (React.createElement(OptionsForm, { product: product, isFormFilled: isFormFilled, setIsFormFilled: setIsFormFilled, isSingleOptionProduct: isSingleOptionProduct, setIsSingleOptionProduct: setIsSingleOptionProduct, setFormValues: setFormValues, onSubmit: onSubmit, loading: isAdding, selectedRelatedProductsSku: selectedRelatedProductsSku, counterValue: counterValue, setCounterValue: setCounterValue, addonCounterValue: addonCounterValue, setAddonCounterValue: setAddonCounterValue, checkedAddon: checkedAddon, onRelatedProductClick: onRelatedProductClick, onColorChange: onColorChange, selectedProductVariant: selectedProductVariant, submitRef: openModalRef, prices: prices, pageReady: pageReady }))),
                            React.createElement(EcoFee, { fee: selectedProductVariant === null || selectedProductVariant === void 0 ? void 0 : selectedProductVariant.eco_fee, locale: locale }),
                            itemCopyDesktop === 'accordion' && (React.createElement(ItemCopy, { description: product.description.html, information: product.information, productTab3: product.additional_tab_one_content, productTab4: product.additional_tab_two_content, accordionExtraContent: accordionExtraContent, isBedOrMattress: [ProductTypeRate.Bed, ProductTypeRate.Mattress].includes(product.product_type_rate) })),
                            itemCopyDesktop === 'tabs' && accordionExtraContent && (React.createElement("div", { className: "accordion-extra-content", dangerouslySetInnerHTML: {
                                    __html: accordionExtraContent,
                                } }))))),
                itemCopyDesktop !== 'accordion' && !!product.description.html && (React.createElement(ItemCopy, { description: product.description.html, information: product.information, productTab3: product.additional_tab_one_content, productTab4: product.additional_tab_two_content, accordionExtraContent: accordionExtraContent })),
                extraContent)),
        !!((_d = product.upsell_products) === null || _d === void 0 ? void 0 : _d.length) && !disableDefaultYmal && (React.createElement(UpsellProducts, { items: product.upsell_products })),
        justAddedData && React.createElement(JustAddedProducts, { data: justAddedData, onClose: closeHandler })));
};

export { ConfigurableProduct as C };
//# sourceMappingURL=ConfigurableProduct-V0kOUHhU.js.map
